// import socket from '@/utils/ws';
import worker from '@/utils/ws/index';
import i18n from 'common-module/src/lang';
import localeMap from 'common-module/src/lang/localeMap';
import IDBSync from '@/utils/idb-sync';
// import { getOrgLanguage } from '@/api/user';
import config from 'common-module/src/config';
import { addTokenChangeListener, TokenKey } from 'common-module/src/util/auth';
import RemoteGuide from 'common-module/src/util/guide';
import dayjs from 'dayjs';

export const initSentry = async (vm, userState) => {
  if (!config.VUE_APP_SENTRY_DSN) {
    return;
  }
  const { userId } = userState.account || {};
  const Sentry = await import('@sentry/vue');

  Sentry.setUser({
    id: userId
  });
};

const initTracker = (vm, userState, ctx, store) => {
  const { userId, orgId, joinedOrgIds } = userState.account || {};
  if (!store?.getters?.['features/isSwitch']?.('event_track')) {
    vm.$track?.ignoreTracking();
  }
  vm.$track?.identify(userId, {
    orgId: joinedOrgIds,
    tenantId: orgId
  });
};

const initNPS = (vm, userState) => {
  const { userId, userName } = userState.account || {};
  if (window.npsmeter) {
    window.npsmeter({ key: config.VUE_APP_NPSMETER_KEY, user_id: userId, user_name: userName });
  }
};

// eslint-disable-next-line no-unused-vars
const meiqiaMetaData = (vm, userState) => {
  if (window._MEIQIA) {
    const { userId, userName, orgId, orgEmail, phoneNumber } = userState.account || {};
    const { orgName, orgKey } = userState.org || {};
    // 美洽不支持 大小写和下划线，只能用全小写
    window._MEIQIA('metadata', {
      // eslint-disable-next-line
      userid: userId,
      name: userName,
      email: orgEmail,
      phone: phoneNumber,
      // eslint-disable-next-line
      orgname: orgName,
      // eslint-disable-next-line
      orgid: orgId,
      // eslint-disable-next-line
      orgkey: orgKey
    });
  }
};

// eslint-disable-next-line no-unused-vars
const intercomMetaData = (vm, userState) => {
  const { userId, userName, orgId, orgEmail, phoneNumber } = userState.account || {};
  const { orgName, orgKey } = userState.org || {};
  if (window.Intercom) {
    // eslint-disable-next-line no-undef
    Intercom('boot', {
      api_base: config.VUE_APP_IC_API,
      app_id: config.VUE_APP_IC_ID,
      email: orgEmail,
      phone: phoneNumber,
      // created_at: 1234567890,
      name: userName,
      user_id: userId,
      // eslint-disable-next-line
      orgname: orgName,
      // eslint-disable-next-line
      orgid: orgId,
      // eslint-disable-next-line
      orgkey: orgKey
    });
  }
};

const initSocket = (vm, userState) => {
  const wsUrl = config.VUE_APP_WS_URL;
  worker.connect(wsUrl, {
    namespace: '/ws',
    query: {
      token: userState.token,
      language: localeMap[i18n.locale]
    },
    userId: userState.account?.userId
  });
};
// const initLanguage = async (vm, userState, ctx, store, token) => {
//   const { language } = await getOrgLanguage(token);
//   i18n.locale = language.slice(0, 2);
// };

const initSync = (vm, userState, ctx, store) => new IDBSync(userState.token, userState.account?.userId, store);

// 当token变化时，同步内存token；当token为空时，刷新页面
let isReloading = false;
let isAddTokenChangeListener = false;
const syncToken = (vm, userState, ctx, store) => {
  if (isAddTokenChangeListener) {
    return;
  }
  isAddTokenChangeListener = true;
  addTokenChangeListener((result) => {
    if (isReloading || result?.name !== TokenKey) {
      return;
    }
    const value = result?.value || '';
    const currentToken = store.getters.token || '';
    if (value !== currentToken) {
      // token变更，如果之前token不为空，则需要刷新页面使用新的token
      if (currentToken) {
        isReloading = true;
        location.reload();
        return;
      }
      store.commit('user/SET_TOKEN', value);
    }
  });
};

let updateUserInfoTimer;
const startUpdateUserInfo = (vm, userState, ctx) => {
  updateUserInfoTimer && clearInterval(updateUserInfoTimer);
  updateUserInfoTimer = setInterval(() => ctx.dispatch('loadUserInfo'), 1000 * 60 * 30);
};

const initRemoteGuide = async (vm, userState, ctx, store) => {
  await RemoteGuide.identify(userState.account?.userId, {
    name: userState.account?.orgUserName,
    email: userState.account?.orgEmail,
    signed_up_at: dayjs(userState.account?.joinTime).toISOString()
  });
  await RemoteGuide.group(store.getters['user/orgId'], { 
    name: store.getters['user/orgName'], 
    key: store.getters['user/orgKey'], 
    language: userState.org?.language, 
    version: store.getters['user/rightVersion']
  }, { 
    roles: userState.roles?.map(role => role.roleCode) ?? []
  });
};

const tryInitList = [syncToken, initSentry, initTracker, initNPS, initSocket, startUpdateUserInfo, initSync, initRemoteGuide];

                 
                                    
        
tryInitList.unshift(intercomMetaData);
         

export default (vm, userState, ctx, store, token) => {
  tryInitList.forEach(async fn => {
    try {
      await fn(vm, userState, ctx, store, token);
    } catch (e) {
      console.warn(`init 【${fn.name}】 error`, e);
    }
  });
};
